import { render, staticRenderFns } from "./json.vue?vue&type=template&id=6b03f423"
import script from "./json.vue?vue&type=script&lang=js"
export * from "./json.vue?vue&type=script&lang=js"
import style0 from "./json.vue?vue&type=style&index=0&id=6b03f423&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports